import Image, { StaticImageData } from "next/image";

interface SlideBackgroundProps {
  imageSrc?: string | StaticImageData;
  fallbackText: string;
  alt?: string;
}

export default function SlideBackground({
  imageSrc,
  fallbackText,
  alt = "Hero background",
}: SlideBackgroundProps) {
  return (
    <div className="absolute inset-0 overflow-hidden flex items-center justify-center">
      {/* Background Image or Placeholder */}
      {imageSrc ? (
        <Image
          src={imageSrc}
          alt={alt}
          fill
          className="object-cover object-center"
          priority
          quality={100}
          sizes="100vw"
        />
      ) : (
        <div className="absolute inset-0 bg-white flex items-center justify-center">
          <span className="text-gray-500 text-lg font-medium">
            {fallbackText}
          </span>
        </div>
      )}
    </div>
  );
}
